import { useCallback, useReducer } from 'react'

export const useSort = (initialSort = {}) => {
  const [state, dispatch] = useReducer((state, action) => {
    switch (action.type) {
      case 'toggle': {
        if (!state[action.payload]?.order) {
          return { [action.payload]: { order: 'asc' } }
        } else if (state[action.payload]?.order === 'asc') {
          return { [action.payload]: { order: 'dsc' } }
        }

        return {}
      }

      default: {
        return state
      }
    }
  }, initialSort)

  const toggleSort = useCallback(
    /**
         *
         * @param {string} field
         */
    (field) => {
      dispatch({ type: 'toggle', payload: field })
    }
    , [dispatch])

  return [state, toggleSort]
}
